<h2 mat-dialog-title>{{ data.title }}</h2>
<div mat-dialog-content>
  <p class="text-muted" *ngIf="data.note">{{ data.note }}</p>
  <div class="row">
    <ng-container *ngFor="let f of data.fields">
      <div [class]="cols(f)" [ngSwitch]="f.type">
        <mat-form-field class="full-width" *ngSwitchCase="'text'">
          <mat-label>{{ f.label }}</mat-label>
          <input matInput [(ngModel)]="model[f.key]" [name]="f.key" [readonly]="f.readonly" [placeholder]="f.placeholder || ''" autocomplete="off" />
          <mat-hint *ngIf="f.hint">{{ f.hint }}</mat-hint>
        </mat-form-field>
        <mat-form-field class="full-width" *ngSwitchCase="'textarea'">
          <mat-label>{{ f.label }}</mat-label>
          <textarea matInput rows="2" [(ngModel)]="model[f.key]" [name]="f.key" [readonly]="f.readonly"></textarea>
          <mat-hint *ngIf="f.hint">{{ f.hint }}</mat-hint>
        </mat-form-field>
        <mat-form-field class="full-width" *ngSwitchCase="'number'">
          <mat-label>{{ f.label }}</mat-label>
          <input matInput type="number" [(ngModel)]="model[f.key]" [name]="f.key" [readonly]="f.readonly" />
          <mat-hint *ngIf="f.hint">{{ f.hint }}</mat-hint>
        </mat-form-field>
        <mat-form-field class="full-width" *ngSwitchCase="'select'">
          <mat-label>{{ f.label }}</mat-label>
          <mat-select [(ngModel)]="model[f.key]" [name]="f.key" [disabled]="f.readonly">
            <mat-option *ngFor="let o of f.options" [value]="o.value">{{ o.label }}</mat-option>
          </mat-select>
          <mat-hint *ngIf="f.hint">{{ f.hint }}</mat-hint>
        </mat-form-field>
        <mat-form-field class="full-width" *ngSwitchCase="'multiselect'">
          <mat-label>{{ f.label }}</mat-label>
          <mat-select multiple [(ngModel)]="model[f.key]" [name]="f.key" [disabled]="f.readonly">
            <mat-option *ngFor="let o of f.options" [value]="o.value">{{ o.label }}</mat-option>
          </mat-select>
          <mat-hint *ngIf="f.hint">{{ f.hint }}</mat-hint>
        </mat-form-field>
        <div *ngSwitchCase="'checkbox'" style="padding-top: 14px">
          <mat-checkbox [(ngModel)]="model[f.key]" [name]="f.key" [disabled]="f.readonly">{{ f.label }}</mat-checkbox>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-raised-button class="piButton" (click)="onSave()">{{ data.saveLabel || "Save" }}</button>&nbsp;
  <button mat-raised-button class="piButton" (click)="onCancelClick()">Cancel</button>&nbsp;
  <button mat-raised-button class="piButton" *ngIf="data.renameLabel" (click)="onRename()">{{ data.renameLabel }}</button>&nbsp;
  <button mat-raised-button class="piButton" *ngIf="data.deleteLabel" (click)="onDelete()">{{ data.deleteLabel }}</button>
</div>
